/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PopupWrapperComponent } from './popup-wrapper/popup-wrapper.component';
import { SimplePopupComponent } from './simple-popup/simple-popup.component';
import { PopupAnchor } from './popup-anchor.directive';
import { PopupCoreService } from './popup-core.service';
import { PopupService } from './popup.service';

/** Jump to [[PopupCoreService]] for doc */

//the angular base
@NgModule({
	imports: [CommonModule],
	declarations: [PopupWrapperComponent, SimplePopupComponent, PopupAnchor],
	providers: [PopupCoreService, PopupService],
	exports: [SimplePopupComponent, PopupAnchor],
})
export class PopupModule {}
